import React from "react";

interface CustomPageProps {
  content: {
    blocks: Array<{
      id: string;
      type: "text" | "image" | "table" | "video" | "iframe";
      data: any;
    }>;
  };
}

const CustomPage: React.FC<CustomPageProps> = ({ content }) => {
  // Placeholder for custom page content
  // In a real implementation, this would render different block types
  return (
    <div className="w-full max-w-4xl mx-auto">
      {content && content.blocks ? (
        content.blocks.map((block) => (
          <div key={block.id} className="mb-6">
            {block.type === "text" && (
              <div 
                className="prose max-w-none" 
                dangerouslySetInnerHTML={{ __html: block.data.text }} 
              />
            )}
            {block.type === "image" && (
              <div className="flex justify-center">
                <img 
                  src={block.data.url} 
                  alt={block.data.caption || ""} 
                  className="max-w-full h-auto rounded-md"
                />
              </div>
            )}
            {/* Other block types would be implemented here */}
          </div>
        ))
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-500">אין תוכן להצגה</p>
        </div>
      )}
    </div>
  );
};

export default CustomPage;
